module.exports = __webpack_public_path__ + "img/SKMJ_workprocess.528fbcc0.png";